import { render, staticRenderFns } from "./ReplaceByDelete.vue?vue&type=template&id=0889ff48&scoped=true"
import script from "./ReplaceByDelete.vue?vue&type=script&lang=js"
export * from "./ReplaceByDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889ff48",
  null
  
)

export default component.exports